module.exports = __webpack_public_path__ + "static/Cloaker-26df2cef0f5a95992be8fbb8dafc4987.jpg";